import { Add as AddIcon } from '@material-ui/icons';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, makeStyles, TextareaAutosize, Typography } from '@material-ui/core';
import { useState } from 'react';
import axios from 'axios';



let useStyles = makeStyles(() => ({
    textArea: {
        width: '100%',
        padding: 10,
        fontFamily: "\"Open Sans\", sans-serif"
    }
}))

interface IProps {
    onClose: () => void
}

let BulkInsert = (props: IProps) => {
    let classes = useStyles();

    let [isOpen, setOpen] = useState(false);
    let [isSaving, setSaving] = useState(false);
    let [serialNumbers, setSerialNumbers] = useState('');


    let open = () => {
        setSerialNumbers('');
        setOpen(true);
    }

    let insertInBulk = async () => {
        try {
            setSaving(true);
            await axios.post('/api/SerialNumbers/BulkInsertSerialNumbers', { serialNumbers });
            props.onClose();
            setOpen(false);
        } catch (err) {
            setSaving(false);
        }
    }


    return (
        <>
            <Button variant="contained" color="primary" size="small" onClick={open}>
                <AddIcon />&nbsp;Bulk insert
            </Button>

            <Dialog
                open={isOpen}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle disableTypography id="alert-dialog-title">
                    <Typography variant="h4">Add multiple serial numbers</Typography>
                    <Typography variant="body2">Insert up to 200 serial numbers each on a new line</Typography>
                </DialogTitle>
                <DialogContent>
                    <TextareaAutosize
                        minRows={35}
                        value={serialNumbers}
                        className={classes.textArea}
                        onChange={(e) => setSerialNumbers(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button disabled={isSaving} variant="outlined" onClick={() => setOpen(false)}>
                        Cancel
                    </Button>
                    <Button
                        disabled={isSaving}
                        variant="contained"
                        color="primary"
                        onClick={async () => insertInBulk()}
                    >
                        Confirm{isSaving && <>&nbsp;<CircularProgress size={20} /></>}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default BulkInsert;